import type { Client } from '@/types';

/**
 * The client's contact phone number for merge-field resolution.
 *
 * `contacts` is only populated by the Finance System detail call
 * (`/clients/{id}/financials`); the client list used by the billing screens
 * comes from `/clients`, which carries the synced `phoneNumber` instead. Both
 * are checked so `{client.phone}` resolves in either case.
 */
export function getClientPhone(client?: Client | null): string | undefined {
  if (!client) return undefined;
  const contactPhone =
    client.contacts?.find((c) => c.role === 'primary')?.phone ??
    client.contacts?.find((c) => c.phone)?.phone;
  return contactPhone || client.phoneNumber || undefined;
}
